

export const anonymousMenuItems = [


    {
        id: 1,
        label: 'Accueil',
        icon: '',
        withIcon: true,
        subItems:[],
        link: '/', 
        
    },

    {
        id: 2,
        label: 'Fonctionnalités',
        link: '/',
        hash: 'features',
        icon: '4',
     
    },
    
    {
        id: 3,
        label: 'Reférences',
        link: '/',
        hash: 'references',
        icon: '4',
    },

    {
        id: 5,
        label: 'Contact',
        link: '/contacter-nous',

    },

    {
        id: 6,
        label: 'Essai gratuit',
        // link: '/essai',
        link: '/', 

    },
 

];

